import { render, staticRenderFns } from "./MicrobiologyMainView.vue?vue&type=template&id=0693e61a"
import script from "./MicrobiologyMainView.vue?vue&type=script&lang=js"
export * from "./MicrobiologyMainView.vue?vue&type=script&lang=js"
import style0 from "./MicrobiologyMainView.vue?vue&type=style&index=0&id=0693e61a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports